// temporary view for a custom report until we get a full new infrastructure in place
PJQ.views.reporting.SubcontractorDiversityStatusExportModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'Modal-Subcontractor-Diversity-Status-Export'),
		maxWidth: 600
	},
	events: {
		'click .export': 'export',
	},
	afterModalCreated: function () {
	},
	beforeRender: function () {
	},
	afterRender: function () {
		this.statePicker = new PJQ.inputs.StatePicker({
			el: this.$('select.input-select-state'),
			country: 'US',
			defaultValue: null,
			isMultiple: true,
			onChange: _.bind(function (value) {
				$('.export').prop('disabled', _.size(value) === 0);
			}, this)
		});
	},
	export: function () {
		let options = this.model.get('options');
		options[0].value.values = this.statePicker.getValue();

		if (typeof this.options.onDownload === 'function') {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.options.onDownload(this.model.get('options'), _.bind(function () {
				loader.remove();
				this.removeModal();
			}, this));
		}
	}
});

PJQ.views.reporting.ReportView = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-view'),
		subTemplates: {
			reportError: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-error'),
			testReport: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'test-report'),
			extraParameters: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-extra-parameters')
		}
	},
	events: {
		'click .export-report': 'exportReport',
		'click .btn-reload-report': 'reloadReport'
	},
	beforeFirstRender: function () {
		let fnRender = _.bind(function () {
			this.render();
		}, this);

		if (!this.collection) {
			this.collection = new PJQ.collections.reports.ReportList(null, {
				project: this.options.project
			});
		}
		if (!this.collection.isFetched) {
			this.collection.fetch({
				success: _.bind(function () {
					fnRender();
				}, this)
			})
		}
		else {
			fnRender();
		}
	},
	renderData: function () {
		return {
			reportList: this.collection,
			selectedReport: this.selectedReport
		};
	},
	afterRender: function () {
		new PJQ.inputs.Selectpicker({
			el: this.$('.report-list'),
			defaultValue: this.selectedReport ? this.selectedReport.get('reportId') : null,
			onChange: _.bind(function (value) {
				if (value === 'PANTERAMARKETING') {
					this.renderCustomReportMarketing();
				}
				else {
					this.selectedReport = this.collection.get(value);
					this.render();
				}
			}, this)
		});

		this.fromDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.input-date-from'),
			datepickerOptions: {
				defaultDate: this.selectedReport && this.selectedReport.get('fromDateDefault') ? this.calculateDate(this.selectedReport.get('fromDateDefault').replace('Math:', '').split('|')) : new Date(),
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function (value) {
				this.selectedReport.set('fromDate', PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE));
			}, this)
		});
		this.toDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.input-date-to'),
			datepickerOptions: {
				defaultDate: this.selectedReport && this.selectedReport.get('toDateDefault') ? this.calculateDate(this.selectedReport.get('toDateDefault').replace('Math:', '').split('|')) : new Date(),
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function (value) {
				this.selectedReport.set('toDate', PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE));
			}, this)
		});

		// We have to get the Extra Parameters before we can generate the report
		if(this.selectedReport){
			this.renderExtraParameters();
		}
	},
	exportReport: function (e) {
		let $target = $(e.currentTarget),
			type = $target.data('type'),
			reportParams = {};

		if (this.selectedReport.get('hasDateFilter')) {
			reportParams["FromDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.fromDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
			reportParams["ToDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.toDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
		}

		if (this.selectedReport.parameters) {
			_.each(this.selectedReport.parameters.models, _.bind(function (param) {
				reportParams[param.get('name')] = param.get('value');
			}, this))
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'reports'
				},
				{
					endpoint: 'export'
				}
			]), data: {
				reportId: this.selectedReport.get('reportId'),
				projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
				parameters: Object.keys(reportParams).length > 0 ? JSON.stringify(reportParams) : null,
				exportType: type ? type : 'pdf'
			}
		}).post().done(_.bind(function (response) {
			PJQ.files.downloadFile(response.url, {
				isEndpoint: false
			});
		}, this));
	},
	reloadReport: function () {
		this.generateReport(this.selectedReport.parameters);
	},
	renderCustomReportMarketing: function () {
		let $el = this.$('.report-container')
		$el.empty();

		this.$('.custom-hide').addClass('hidden');

		$el.html($('<img>', {
			style: 'width: 100%',
			src: '/portals/_default/customReports.png'
		}));
	},
	renderReport: function (data) {
		if (data) {
			let $el = this.$('.report-container')
			$el.empty();

			if (data.isImage) {
				$el.html($('<img>', {
					style: 'width: 100%',
					src: 'data:image/png;base64,' + data.reportData
				}));
			}
			else {
				let template = data.reportData;
				template = template.replace(`"<!DOCTYPE HTML PUBLIC \\"-//W3C//DTD HTML 4.01 Transitional//EN\\">`, '');
				template = template.replace(/\\/g, '');
				this.$('.report-container').html(template);
			}
		}
	},
	generateReport: function (params) {
		if (this.selectedReport) {
			let loader = new PJQ.Loader(this.$('.report-container'));
			let reportParams = {};

			if (this.selectedReport.get('hasDateFilter')) {
				reportParams["FromDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.fromDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
				reportParams["ToDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.toDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
			}

			if (params) {
				_.each(params.models, _.bind(function (param) {
					reportParams[param.get('name')] = param.get('value');
				}, this))
			}

			new PJQ.ajax.Request({
				endpoint: "/report/GenerateReport",
				data: {
					reportId: this.selectedReport.get('reportId'),
					projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
					parameters: Object.keys(reportParams).length > 0 ? JSON.stringify(reportParams) : null
				}
			}).post().done(_.bind(function (data) {
				loader.remove();
				this.renderReport(data);
			}, this)).fail(_.bind(function () {
				loader.remove();
				this.renderError();
			}, this));
		}
	},
	renderError: function () {
		this.renderSubTemplate(false, this.options.subTemplates.reportError, this.$('.report-container'));
	},
	calculateDate: function (mathArr) {
		let dnow = new Date(),
			thisMonth = dnow.getMonth() + 1,
			thisDay = dnow.getDate(),
			thisYear = dnow.getFullYear(),
			thisMonthMath = mathArr[0],
			thisDayMath = mathArr[1],
			thisYearMath = mathArr[2],
			thisMonthIsStatic = thisMonthMath.toLowerCase().indexOf('s:') != -1 ? true : false,
			thisDayIsStatic = thisDayMath.toLowerCase().indexOf('s:') != -1 ? true : false,
			thisYearIsStatic = thisYearMath.toLowerCase().indexOf('s:') != -1 ? true : false;
		if (thisMonthIsStatic) {
			thisMonth = thisMonthMath.replace('s:', '');
		}
		else {
			thisMonth = thisMonth + parseInt(thisMonthMath);
		}
		if (thisDayIsStatic) {
			thisDay = thisDayMath.replace('s:', '');
		}
		else {
			thisDay = thisDay + parseInt(thisDayMath);
		}
		if (thisYearIsStatic) {
			thisYear = thisYearMath.replace('s:', '');
		}
		else {
			thisYear = thisYear + parseInt(thisYearMath);
		}

		let daysInMonth;
		if (thisDay < 1 && !thisDayIsStatic) {
			if (thisMonthIsStatic) {
				thisDay = 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
			}
			else {
				thisMonth = thisMonth - 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
				thisDay = daysInMonth + thisDay;
			}
		}
		else {
			daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
		}
		if (thisDay > daysInMonth) {
			if (thisMonthIsStatic) {
				thisMonth = thisMonth + 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear)
				thisDay = thisDay - daysInMonth;
			}
			else {
				thisDay = daysInMonth;
			}
		}
		if (thisMonth < 1 && !thisMonthIsStatic) {
			thisMonth = thisMonth + 12;
			if (!thisYearIsStatic) {
				thisYear = thisYear - 1;
			}
		}
		else if (thisMonth > 12 && !thisMonthIsStatic) {
			thisMonth = thisMonth - 12;
			if (!thisYearIsStatic) {
				thisYear = thisYear + 1;
			}
		}

		return new Date(thisYear, thisMonth, thisDay);
	},
	renderExtraParameters: function () {
		if (this.selectedReport && this.selectedReport.get('extraParameters') && this.selectedReport.get('extraParameters') !== 'NULL') {
			this.selectedReport.getExtraParameters(_.bind(function (params) {
				// Render subtemplate with returned parameters
				this.renderSubTemplate(false, this.options.subTemplates.extraParameters, this.$('.extra-parameter-inputs'), {
					extraParams: params.models
				});

				// Add any binders or inputs required for parameters
				_.each(params.models, function (param) {
					if (param.get('inputType').toLowerCase() === 'select') {
						new PJQ.inputs.Selectpicker({
							el: this.$(('select.' + param.cid)),
							defaultValue: param.get('defaultValue'),
							onChange: _.bind(function (value) {
								param.set('value', value);
							}, this)
						});
					}
					else if (param.get('inputType').toLowerCase() === 'date') {
						new PJQ.inputs.Datepicker({
							el: this.$(('.' + param.cid)),
							datepickerOptions: {
								// defaultDate: option.defaultValue ? option.defaultValue.to : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: _.bind(function (value) {
								param.set('value', value);
							}, this)
						});
					}
					else {
						new PJQ.Binder(this.$el, param, {
							watchElements: [
								('.' + param.cid)
							]
						});
					}
				}, this)
				//Generate the report once the parameters are established
				this.generateReport(params);
			}, this));
		}
		else {
			// There are no parameters to worry about, so we can just generate the report
			this.generateReport();
		}
	}
});